import * as React from "react";
import type { SVGProps } from "react";
const SvgTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 33 32"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M25.82 9.748c.23.204.24.546.023.762L14.078 22.231a.6.6 0 0 1-.409.169.6.6 0 0 1-.413-.158l-6.289-5.925a.52.52 0 0 1 0-.763.6.6 0 0 1 .81 0l5.873 5.533L25.01 9.769a.6.6 0 0 1 .81-.021" />
  </svg>
);
export default SvgTick;
